import React, { Component } from "react";
import InputText from "../../../../../common/components/input-text/input-text";
import Button from "../../../../../home/button-classic/button-classic";
import { getCookie } from "../../../../../utils/cookies.js";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import ACTION from "../../../../../common/action_constant";
import { validationCheck } from "../../../../../utils/validate";
import moment from 'moment';
import actions from "../../../../../common/action_constant";
import { DEEPAK_COMPANY_ID } from "Utils/common";
 
 
class AddItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: JSON.parse(getCookie("user")).company_id,
      user_id: JSON.parse(getCookie("user")).user_id,
      user_name: JSON.parse(getCookie("user")).name,
      driver_name: "",
      cell_no: "",
      dl_no: "",
      dob: "",
      driver_acc_no: "",
      driver_ifsc_code: "",
      driver_alternative_location_id: "",
      driver_detail_validity_date: new Date(),
      preferredroute: [],
      dlName: '',
      is_blocked: false,
      block_remarks: "",
      blocked_by: "",
      errorMsg: "",
    };
  }
  componentDidMount() { }
  handleChange = (id, selectedOption) => {
    this.setState({ [id]: selectedOption.label });
  };
  validateCheck = () => {
    const { company_id, driver_name, cell_no, dl_no, driver_detail_validity_date, dlName } = this.state;
    const isDpl = DEEPAK_COMPANY_ID.includes(company_id);
    if (isDpl) {
      return !!(driver_name && dl_no && cell_no);
    }
    return !!(driver_name && cell_no && dl_no && driver_detail_validity_date && dlName);
  };
  onSave = () => {
    const data = this.state;
    const { driver_detail_validity_date, dob } = this.state;
 
    if (!this.validateCheck()) {
      this.setState({
        errorMsg: "Please add all mandatory fields",
      });
      return;
    }
    const hasMaskedData =
      [data.driver_name, data.cell_no, data.driver_alternative_location_id]
        .filter(Boolean)
        .some((field) => field.includes("*"));
 
    // if (hasMaskedData) {
    //   this.setState({
    //     errorMsg:
    //       "Some fields contain masked (*) data. Please enter complete driver details before saving.",
    //   });
    //   return;
    // }
 
    // if (
    //   !driver_detail_validity_date ||
    //   moment(driver_detail_validity_date).isBefore(moment().startOf("day"))
    // ) {
    //   this.setState({
    //     errorMsg: "Please select a valid Driving Licence Validity Date.",
    //   });
    //   return;
    // }
 
    // if (dob && moment().diff(moment(dob), "years") < 18) {
    //   this.setState({
    //     errorMsg: "Driver must be at least 18 years old.",
    //   });
    //   return;
    // }
    this.setState({ errorMsg: "" });
    this.props.toggleAdd();
    this.props.addDriverInfo(data);
  };
 
  addLocation = () => {
    let { preferredroute } = this.state;
    preferredroute.push({ source: "", destination: "" });
    this.setState({ preferredroute });
  };
  deleteLocation = (index) => {
    const { preferredroute } = this.state;
    preferredroute.splice(index, 1);
    this.setState({ preferredroute });
  };
 
  SelectDate = (id, selectedOption) => {
    this.setState({ [id]: selectedOption != null ? selectedOption.valueOf() : null });
  };
 
  onChangeHandler = (value, id, isType) => {
    if (id === 'driver_ifsc_code' || id === 'dl_no') {
      value = value.replace(/[^A-Za-z0-9]/g, '');
      value = value.slice(0, 16);
    }
    const result = validationCheck(value, this.state[id], isType);
    this.setState({ [id]: result });
  }
 
  uploadfiles = (e, name) => {
    const { dispatch } = this.props;
    let formData = new FormData();
    formData.append("file", e.target.files[0]);
    dispatch({
      type: ACTION.DATA_GOVERNANCE.UPLOAD_VEHICLE_FIELS,
      formData,
      uploadFromDriverPopup:true,
      onSuccess: (data) => {
        this.setState({ [name]: data });
      },
    });
  };
 
    handleFileClickWithpresignedUrl = (name = "") => {
 
    const { dispatch } = this.props;
 
    dispatch({
 
      type: actions.HOME.GET_PRESIGNED_DOWNLOAD_URL,
 
      fileName: name,
      trip_id: "",
      method_name: "",
 
      onSuccess: ((link) => {
 
        console.log("link", link);
 
        window.open(link, '_blank');
 
      })
 
    })
 
  }
 
  onChange = (e) => {
    this.uploadfiles(e, "dlName");
  };
 
  handleSwitch = (name) => (checked) => {
    this.setState({ is_blocked: checked });
  };
 
  render() {
    const { preferredroute, company_id } = this.state;
    const isDpl = DEEPAK_COMPANY_ID.includes(company_id);
 
    return (
      <div className="driver-modal">
        <div className="driver-backdrop" onClick={this.props.toggleAdd} />
        <div className="driver-card">
          <h2>Add Driver Info</h2>
          <div className="driver-grid">
            {/* FIRST ROW */}
            <div style={{ display: "flex", gap: "4px" }}>
              {/* DL */}
              <div style={{ flex: 1 }}>
                <InputText
                  label="DL No"
                  placeholder="DL No"
                  id="dl_no"
                  value={this.state.dl_no}
                  changeHandler={this.onChangeHandler}
                  length={"16"}
                  required
                />
              </div>
              {/* DOB */}
              {!isDpl && (
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label
                    style={{
                      fontSize: "13px",
                      color: "#868e96",
                      marginBottom: "6px"
                    }}
                  >
                    Driver DOB <span className="text-danger">*</span>
                  </label>
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={this.state.dob ? new Date(this.state.dob) : null}
                    onChange={this.SelectDate.bind(this, "dob")}
                    placeholderText="DD/MM/YYYY"
                    maxDate={new Date()}
                    popperPlacement="bottom-start"
                    style={{
                      width: "4px",
                      borderRadius: "8px",
                      border: "1px solid #dee2e6",
                      padding: "10px 12px",
                      fontSize: "15px",
                      outline: "none"
                    }}
                  />
                </div>
              </div>
              )}
            </div>
 
            <div className="upload-section">
              {/* Label */}
              <label className="upload-label">
                DL Image {!isDpl && <span className="text-danger">*</span>}
              </label>
              {/* Row container */}
              <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
                {/* Upload Box */}
                <div
                  className="upload-box"
                  onClick={() => this.uploadUrl.click()}
                >
                  {/* Upload Arrow Icon */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    fill="#6c757d"
                    viewBox="0 0 24 24"
                    style={{ marginRight: "10px" }}
                  >
                    <path d="M12 3l4 4h-3v6h-2V7H8l4-4zm-7 14v2h14v-2H5z" />
                  </svg>
                  <span>Upload Image</span>
                </div>
 
                {/* Preview Box */}
                {this.state.previewImage && (
                  <div
                    style={{
                      height: "60px",
                      width: "180px",
                      border: "1px solid #dee2e6",
                      padding: "10px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      background: "#f8f9fa",
                      position: "relative",
                    }}
                  >
                    <span style={{ position: "absolute", top: "-8px", right: "-8px", background: "#ff6b6b", color: "white", width: "22px", height: "22px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", fontSize: "14px", fontWeight: "bold", }}
                      onClick={() =>
                        this.setState({
                          previewImage: null,
                          dlName: null,
                        })
                      }
                    >×</span>
 
                    <img
                      src={this.state.previewImage}
                      alt="DL Preview"
                      style={{
                        width: "52px",
                        height: "40px",
                        borderRadius: "6px",
                        objectFit: "cover",
                        border: "1px solid #ced4da",
                      }}
                    />
 
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span style={{ fontSize: "12px", color: "#495057" }}>
                        {this.state.dlName?.name}
                      </span>
                      <div
                        className="fs-12 mt-5 curP"
                        onClick={() =>
                          this.handleFileClickWithpresignedUrl(this.state.dlName?.name)
                        }
                      >
                        {this.state.dlName?.name}
                      </div>
                    </div>
                  </div>
                )}
 
              </div>
 
              {/* Hidden Input */}
              <input
                type="file"
                ref={(e) => (this.uploadUrl = e)}
                style={{ display: "none" }}
                accept=".jpeg, .jpg, .png"
                onChange={(e) => {
                  this.onChange(e);
                  const file = e.target.files[0];
                  if (file) {
                    this.setState({
                      previewImage: URL.createObjectURL(file),
                      dlName: { name: file.name, url: URL.createObjectURL(file) },
                    });
                  }
                }}
                onClick={(e) => (e.target.value = null)}
              />
            </div>
 
            <div
              style={{
                marginTop: "12px",
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                columnGap: "4px",
                rowGap: "42px",
              }}
            >
              <InputText
                label="Driver Name"
                id="driver_name"
                value={this.state.driver_name}
                placeholder="Driver Name"
                changeHandler={this.onChangeHandler}
                length={"45"}
                required
              />
              <InputText
                label="Driver Contact"
                id="cell_no"
                value={this.state.cell_no}
                placeholder="Driver Contact"
                changeHandler={this.onChangeHandler}
                length={"10"}
                isValidate={"numeric"}
                required
              />
              <InputText
                label="Driver Location"
                id="driver_alternative_location_id"
                value={this.state.driver_alternative_location_id}
                placeholder="Driver Location"
                changeHandler={this.onChangeHandler}
                length={"45"}
              />
              <InputText
                label="Driver A/C No"
                id="driver_acc_no"
                value={this.state.driver_acc_no}
                placeholder="Driver A/C No"
                changeHandler={this.onChangeHandler}
                length={"17"}
              />
              <InputText
                label="IFSC"
                id="driver_ifsc_code"
                value={this.state.driver_ifsc_code}
                placeholder="IFSC"
                changeHandler={this.onChangeHandler}
                length={"11"}
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label style={{
                  fontSize: "13px",
                  color: "#868e96",
                  marginBottom: "6px"
                }}>
                  DL validity date {!isDpl && <span className="text-danger">*</span>}
                </label>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={this.state.driver_detail_validity_date ? new Date(this.state.driver_detail_validity_date) : null}
                  onChange={this.SelectDate.bind(
                    this,
                    "driver_detail_validity_date"
                  )}
                  placeholderText={"DD/MM/YYYY"}
                  required
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                    border: "1px solid #dee2e6",
                    padding: "10px 12px",
                    fontSize: "15px",
                    outline: "none"
                  }}
                  popperPlacement="bottom-start"
                />
              </div>
            </div>
 
            <div className="location-wrapper">
              <div className="location-header">
                <h3>Add Location</h3>
                <button className="btn-add" onClick={this.addLocation}>+ Add</button>
              </div>
              {preferredroute.map((value, index) => (
                <div className="location-row" key={index}>
                  <div className="form-field">
                    <InputText
                      label="Source"
                      placeholder="Source"
                      value={value.source}
                      changeHandler={(v) => {
                        let preferredroute = [...this.state.preferredroute];
                        preferredroute[index].source = v;
                        this.setState({ preferredroute });
                      }}
                    />
                  </div>
 
                  <div className="form-field">
                    <InputText
                      label="Destination"
                      placeholder="Destination"
                      value={value.destination}
                      changeHandler={(v) => {
                        let preferredroute = [...this.state.preferredroute];
                        preferredroute[index].destination = v;
                        this.setState({ preferredroute });
                      }}
                    />
                  </div>
 
                  <button
                    className="btn-delete"
                    onClick={() => this.deleteLocation(index)}
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
 
          </div>
            {this.state.errorMsg && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginTop: "8px",
                        padding: "8px 10px",
                        borderRadius: "6px",
                        backgroundColor: "rgba(244, 67, 54, 0.1)",
                        border: "#F44336",
                        color: "#C62828",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >{this.state.errorMsg}</div>
                  )}
          <div className="driver-footer">
            <Button
              value="Cancel"
              className="btn-outline"
              click={this.props.toggleAdd}
            />
 
            <Button
              value="Save"
              className="btn-primary"
              click={this.onSave}
            />
          </div>
        </div>
      </div>
    );
  }
}
 
export default connect()(AddItem);
